import { ref, computed, watchEffect } from 'vue';
import Request from '@/services/request';
import {
  HISTORY_TAB_DOWNLOAD_URL,
  HISTORY_TAB_UPLOAD_URL
} from '@/utils/enum/endpoints';

import {
  HISTORY_TAB_UPLOAD,
  HISTORY_TAB_DOWNLOAD,
  HEADER_TAB_UPDATE
} from '@/utils/enum/bulkActionTabs';

import {
  handleExcelReportUrlParams
} from '@/utils/enum/urlParamHandler';

const Req = new Request();

const DEFAULT_PAGE_COUNT = -1;
const DEFAULT_RESULT_COUNT = -1;

export default function useService(pagination) {
  const data = ref(null);
  const totalResultCount = ref(DEFAULT_RESULT_COUNT);
  const error = ref(null);
  const isLoading = ref(false);
  const request = ref(null);
  const pageCount = ref(DEFAULT_PAGE_COUNT);
 
  handleExcelReportUrlParams(pagination, HISTORY_TAB_DOWNLOAD, HEADER_TAB_UPDATE);

  const requestParams = computed(() => {
    const { pageSize, pageIndex } = pagination.value;
    const currentPage = pageIndex;

    return {
      page: currentPage,
      size: pageSize,
      type: pagination.value.tab
    };
  });

  watchEffect(() => {
    isLoading.value = true;
    let endpoint = null;
    switch(pagination.value.type) {
      case HISTORY_TAB_DOWNLOAD:
        endpoint = HISTORY_TAB_DOWNLOAD_URL;
        break;
      case HISTORY_TAB_UPLOAD:
        endpoint = HISTORY_TAB_UPLOAD_URL;
        break;
    }

    request.value = Req.get(endpoint, requestParams.value)
      .then(async (response) => {
        if (response.status === 200) {
          if (pagination.value.type === HISTORY_TAB_UPLOAD) {
            data.value = response.data.uploadedFileHistoryDTOList || [];
            totalResultCount.value = response.data.pageable?.totalItemCount || DEFAULT_RESULT_COUNT;
            pageCount.value = response.data.pageable?.totalPageCount || DEFAULT_PAGE_COUNT;
          } else if (pagination.value.type === HISTORY_TAB_DOWNLOAD) {
            data.value = response.data.content || [];
            totalResultCount.value = response.data.totalElements || DEFAULT_RESULT_COUNT;
            pageCount.value = response.data.totalPages || DEFAULT_PAGE_COUNT;
          }
          error.value = null;
        } else {
          throw new Error('Network response was not OK');
        }
      })
      .catch((err) => {
        error.value = err || null;
        data.value = null;
        totalResultCount.value = DEFAULT_RESULT_COUNT;
        pageCount.value = DEFAULT_PAGE_COUNT;
      })
      .finally(() => {
        isLoading.value = false;
      });
  });

  return {
    data,
    totalResultCount,
    pageCount,
    error,
    isLoading
  };
}
